// @ts-nocheck
import adjustableScrollToId from "@store/Framework/Common/Utilities/adjustableScrollToId";
import getHeaderHeight from "@store/Framework/Common/Utilities/getHeaderHeight";
import Link, { LinkProps } from "@insite/mobius/Link";
import React from "react";

export interface StoreAnchorProps {
    fields: {
        linkTitle: string;
    };
}

export interface StoreAnchorLinkProps extends StoreAnchorProps, LinkProps {}

const StoreAnchorLink: React.FC<StoreAnchorLinkProps> = ({ fields, ...otherProps }) => {
    const headerHeight = getHeaderHeight();

    const onClickHandler = () => {
        adjustableScrollToId(fields.linkTitle, headerHeight, true);
    };

    return (
        <Link onClick={onClickHandler} {...otherProps}>
            {fields.linkTitle}
        </Link>
    );
};

export default StoreAnchorLink;
